import React, { createContext, useContext, useEffect, useState } from "react";
import { getMenuScheduleData } from "services/HomeService";

interface MenuScheduleItem {
  menuDay: string;
  fromTime: string;
  toTime: string;
  // Add more fields if the API response includes more
}
interface MenuScheduleResponse {
  data: {
    schedules: MenuScheduleItem[];
  };
}

interface MenuScheduleContextProps {
  data: MenuScheduleItem[] | null;
  isLoading: boolean;
  error: string | null;
}

const MenuScheduleContext = createContext<MenuScheduleContextProps | undefined>(undefined);

export const MenuScheduleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<MenuScheduleItem[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const response = await getMenuScheduleData();
      
       const menuScheduleResponse = response as MenuScheduleResponse;

if (Array.isArray(menuScheduleResponse?.data)) {
  setData(menuScheduleResponse.data[0]?.schedules ?? null);
} else {
  setData(menuScheduleResponse.data?.schedules ?? null);
}
      } catch (err: any) {
        setError(err.message || "Failed to load menu schedule");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSchedule();
  }, []);

  return (
    <MenuScheduleContext.Provider value={{ data, isLoading, error }}>
      {children}
    </MenuScheduleContext.Provider>
  );
};

export const useMenuSchedule = () => {
  const context = useContext(MenuScheduleContext);
  if (context === undefined) {
    throw new Error("useMenuSchedule must be used within a MenuScheduleProvider");
  }
  return context;
};
